// React
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { categories } from "../../Config/MainCategory";
// Utilities
import cookie from "react-cookies";
import timeMonth from "../../Config/TimeMonth";
// Components
import TitleBar from "./Components/TitleBar";
import Loading from "../../Others/Loading";
// import StoreCard from "./Components/StoreCard";
import MenuBar from "../MenuBar";
import ChangeAddress from "./Components/ChangeAddress";
// import { calcDist } from "../../Others/functions";
import ItemCatalogue from "./Components/Homepage/HomePageSelectItems/ItemCatalogue";
import Combo from "./Components/Homepage/Combo/ComboMain";
import CategorySec from "./Components/Homepage/CategorySec/CategorySec";
import AddedToCartBtmSheet from "./Components/Homepage/UI-item,viewAll,BtmSheet/AddedToCartBtmSheet";

//images
import lowestPriceEver from "../../img/icon-lowest-price.png";
import beattTheHeat from "../../img/icon-beat-heat.gif";
import breakfast from "../../img/icon-breakfast.gif";
import ItemCatalogue_NoViewAll from "./Components/Homepage/HomePageSelectItems/ItemCatalogue_NoViewAll";
import RuppeOne from "../../Pages/RuppeeOne/RuppeOne";
import HomePageOrderTracking from "../../Pages/Orders/HomePageOrderTracking";
import CarouselSec from "./Components/Homepage/Carousels/CarouselSec";
import { useTranslation } from "react-i18next";
const { hour, month } = timeMonth;

export default function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const debounceRef = useRef();
  const [bottomPadding, setBottomPadding] = useState(0);
  const measureHeight = () => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      setBottomPadding(
        document.getElementById("homeBottomSheets")?.offsetHeight
      );
    }, 150);
  };
  useEffect(() => {
    window.addEventListener("scroll", measureHeight);
    return () => {
      window.removeEventListener("scroll", measureHeight);
    };
  }, []);

  useEffect(() => {
    if (!cookie.load("uid") && !cookie.load("visitor")) navigate("/");
    document.body.style.overflow = "auto !important";
  }, [navigate]);

  const user = useSelector((state) => state.user);
  // console.log(user);
  return user?.currentLocation ? (
    <>
      <TitleBar />

      <MenuBar active="Home" />
      <ChangeAddress />
      <CarouselSec />
      <Combo />

      <ItemCatalogue_NoViewAll
        title={t("LOWEST PRICE EVER!")}
        param="getCategoriesProduct/lowest"
        titleImage={lowestPriceEver}
      />
      {/* -------------------hourly freshness------------------ */}
      {hour >= 4 && hour < 11 && (
        <ItemCatalogue
          title={t("Tasty Breakfast")}
          subtitle={t("with poha, idli and more")}
          param="getCategoriesProduct/breakfast"
          theme={true} //the background color of the card
          titleImage={breakfast}
        />
      )}
      {hour >= 11 && hour < 15 && (
        <ItemCatalogue
          title={t("Yummy Lunch")}
          subtitle={t("with rice, dal and more")}
          param="getCategoriesProduct/lunch"
          theme={true} //the background color of the card
          titleImage={breakfast}
        />
      )}
      {hour >= 15 && hour < 18 && (
        <ItemCatalogue
          title={t("Evening Snacks")}
          subtitle={t("with tea, namkeen, biscuits and more")}
          param="getCategoriesProduct/evening"
          theme={true} //the background color of the card
          titleImage={breakfast}
        />
      )}
      {hour >= 18 && (
        <ItemCatalogue
          title={t("Healthy Dinner")}
          subtitle={t("with tea, namkeen, biscuits and more")}
          param="getCategoriesProduct/dinner"
          theme={true} //the background color of the card
          titleImage={breakfast}
        />
      )}
      {/* -------------------Season freshness------------------ */}
      {month >= 1 && month <= 2 && (
        <ItemCatalogue
          title={t("Protect from Winter")}
          subtitle={t("with cold cream, dry fruits and more")}
          param="getCategoriesProduct/winter"
          theme={false}
          titleImage={beattTheHeat}
        />
      )}
      {month >= 3 && month <= 4 && (
        <ItemCatalogue
          title={t("Goodbye Winter, Welcome Summer")}
          subtitle={t("with mosquito repellents, cloth softener and more")}
          param="getCategoriesProduct/spring"
          theme={false}
          titleImage={beattTheHeat}
        />
      )}
      {month >= 5 && month <= 6 && (
        <ItemCatalogue
          title={t("Beat the Summer")}
          subtitle={t("with drinks, juices, ice cream and more")}
          param="getCategoriesProduct/summer"
          theme={false}
          titleImage={beattTheHeat}
        />
      )}
      {month >= 7 && month <= 8 && (
        <ItemCatalogue
          title={t("Enjoy the Monsoon")}
          subtitle={t("with tea, snacks and more")}
          param="getCategoriesProduct/monsoon"
          theme={false}
          titleImage={beattTheHeat}
        />
      )}
      {month >= 9 && month <= 10 && (
        <ItemCatalogue
          title={t("Biggest Celebration Months")}
          subtitle={t("celebrate Diwali and Navratre with us")}
          param="getCategoriesProduct/autumn"
          theme={false}
          titleImage={beattTheHeat}
        />
      )}
      {month >= 11 && month <= 12 && (
        <ItemCatalogue
          title={t("Winter is coming")}
          subtitle={t("with dry fruits and hot tea")}
          param="getCategoriesProduct/prewinter"
          theme={false}
          titleImage={beattTheHeat}
        />
      )}
      <div className="homeBottomSheets" id="homeBottomSheets">
        <RuppeOne />
        <AddedToCartBtmSheet screenName={categories[0]} />
        <HomePageOrderTracking />
      </div>
      <div
        style={{
          paddingBottom: `${bottomPadding}px`,
        }}
      >
        <CategorySec />
      </div>
    </>
  ) : (
    <Loading text="Searching stores..." />
  );
}
